





















































import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { formatDate, isAfter, parseISO } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import FormatMoney from "@/components/FormatMoney";
import ListItem from "@/components/ListItem";

const SHORT_DATE_OPTIONS = { month: "short", day: "2-digit" } as const;

export default defineComponent({
  name: "SubscriptionItemView",
  components: { ListItem, BaseAvatar, FormatMoney },
  props: {
    subscription: { type: Object as () => Subscription, required: true },
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    nextRebillDate(): string {
      if (this.subscription.recurringBillingSchedule?.schedule.nextBillingTime) {
        return formatDate(
          new Date(this.subscription.recurringBillingSchedule.schedule.nextBillingTime),
          SHORT_DATE_OPTIONS
        );
      }
      return "";
    },
    expireDate(): string {
      return formatDate(new Date(this.subscription.expirationTime), SHORT_DATE_OPTIONS);
    },
    lastRebillDate(): string {
      if (this.subscription.recurringBillingSchedule?.lastBillingTime) {
        return formatDate(new Date(this.subscription.recurringBillingSchedule.lastBillingTime), SHORT_DATE_OPTIONS);
      }
      return "";
    },
    canceled(): boolean {
      return this.subscription.recurringBillingSchedule?.cancelled ?? true;
    },
    profileUrl(): Location {
      return getProfileUrl(this.subscription.provider);
    },
    cost(): number {
      return this.subscription.recurringBillingSchedule?.cost.cost ?? Number(this.subscription.amount);
    },
    currencyCode(): string | undefined {
      return this.subscription.recurringBillingSchedule?.cost.currency;
    },
    cancelTitle(): string {
      if (!this.subscription.recurringBillingSchedule) return "";
      return $t("Cancel rebill of {amount} subscription to {screenName}?", {
        amount: formatMoneyString(this.cost, { currencyCode: this.currencyCode }),
        screenName: this.subscription.provider.screenName,
      });
    },
    cancelDescription(): string {
      return $t("Content will be available until {0}.", [this.expireDate]);
    },
    expireText(): string {
      if (isAfter(new Date(), parseISO(this.subscription.expirationTime))) {
        return $t("Expired on {0}", [this.expireDate]);
      }
      return $t("Expires {0}", [this.expireDate]);
    },
  },
  methods: {
    onCancelRebill({ title, description }: { title: string; description: string }) {
      if (this.processing || !this.subscription.recurringBillingSchedule) return;
      this.processing = true;
      this.$emit(
        "cancel",
        { recurring: this.subscription.recurringBillingSchedule, title, description },
        () => (this.processing = false)
      );
    },
  },
});
